module.exports = __webpack_public_path__ + "media/flags/013-russia-4cee3eaf.svg";